/* Variant picker (dvp).
   Reads the per-variant data rendered by snippets/variant-picker.liquid, resolves the
   variant matching the currently chosen option values, then rewrites the parts of the
   product page that depend on it: price, compare-at / save badge, availability, SKU and
   barcode, the hidden add-to-cart target, the buy-now link, the sticky buy bar and the
   gallery image.
   Plain JS with no web components — matches the rest of this theme (dna2.js). */
(function () {
  'use strict';

  function init(root) {
    if (root.getAttribute('data-dvp-ready')) return;
    root.setAttribute('data-dvp-ready', 'true');

    var dataEl = root.querySelector('[data-dvp-json]');
    if (!dataEl) return;

    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var variants = data.variants || [];
    var options = data.options || [];
    if (!variants.length || !options.length) return;

    var page = document;
    var el = {
      vid: page.querySelector('[data-dvp-vid]'),
      now: page.querySelector('[data-dvp-now]'),
      was: page.querySelector('[data-dvp-was]'),
      save: page.querySelector('[data-dvp-save]'),
      sku: page.querySelector('[data-dvp-sku]'),
      skuWrap: page.querySelector('[data-dvp-sku-wrap]'),
      barcode: page.querySelector('[data-dvp-barcode]'),
      barcodeWrap: page.querySelector('[data-dvp-barcode-wrap]'),
      buyPrice: page.querySelector('[data-dvp-buy-price]'),
      buyRow: page.querySelector('[data-dvp-buy-row]'),
      soldOut: page.querySelector('[data-dvp-soldout]'),
      buyNow: page.querySelector('[data-dvp-buynow]'),
      delivFree: page.querySelector('[data-dvp-deliv-free]'),
      delivPaid: page.querySelector('[data-dvp-deliv-paid]'),
      img: page.getElementById('gimg'),
      thumbs: page.querySelectorAll('.thumbs .t'),
      stickyPrice: page.querySelector('[data-dvp-sticky-price]'),
      stickyBtn: page.querySelector('[data-dvp-sticky-btn]')
    };

    var inputs = root.querySelectorAll('[data-dvp-input]');
    var note = root.querySelector('[data-dvp-note]');
    var freeMin = Number(data.free_min) || 0;

    /* the currently chosen input for an option position: the checked radio, or the select */
    function inputAt(pos) {
      return root.querySelector('[data-dvp-input][data-opt-pos="' + pos + '"]:checked') ||
             root.querySelector('select[data-dvp-input][data-opt-pos="' + pos + '"]') ||
             root.querySelector('[data-dvp-input][data-opt-pos="' + pos + '"]');
    }

    function selectedValues() {
      var vals = [];
      for (var i = 0; i < options.length; i++) {
        var node = inputAt(i + 1);
        vals.push(node ? node.value : '');
      }
      return vals;
    }

    function findVariant(vals) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], hit = true;
        for (var j = 0; j < options.length; j++) {
          if (!vals[j] || v.options[j] !== vals[j]) { hit = false; break; }
        }
        if (hit) return v;
      }
      return null;
    }

    function byId(id) {
      if (id === null || id === undefined) return null;
      var want = String(id);
      for (var i = 0; i < variants.length; i++) if (String(variants[i].id) === want) return variants[i];
      return null;
    }

    /* Would choosing `value` for option `pos` still lead to a real variant, given the other
       options' current choices? Only combinations that do not exist are greyed out — a
       sold-out variant stays selectable so its price and "sold out" state can be seen. */
    function valueExists(pos, value) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (v.options[pos - 1] !== value) continue;
        var ok = true;
        for (var j = 0; j < options.length; j++) {
          var n = j + 1;
          if (n === pos) continue;
          var node = inputAt(n);
          if (node && node.value && v.options[j] !== node.value) { ok = false; break; }
        }
        if (ok) return true;
      }
      return false;
    }

    function setText(node, text) { if (node) node.textContent = text; }
    function show(node, on) { if (node) node.style.display = on ? '' : 'none'; }

    function updateRadios() {
      for (var i = 0; i < options.length; i++) {
        var boxes = root.querySelectorAll('[data-dvp-input][data-opt-pos="' + (i + 1) + '"]');
        for (var b = 0; b < boxes.length; b++) {
          if (boxes[b].type === 'radio') boxes[b].disabled = !valueExists(i + 1, boxes[b].value);
        }
      }
    }

    function updateLabels() {
      for (var i = 0; i < options.length; i++) {
        var pos = i + 1, node = inputAt(pos);
        setText(root.querySelector('[data-dvp-val][data-opt-pos="' + pos + '"]'), node ? node.value : '');
      }
    }

    function syncInputs(v) {
      for (var i = 0; i < options.length; i++) {
        var pos = i + 1, want = v.options[i];
        var boxes = root.querySelectorAll('[data-dvp-input][data-opt-pos="' + pos + '"]');
        for (var b = 0; b < boxes.length; b++) {
          if (boxes[b].type === 'radio') boxes[b].checked = boxes[b].value === want;
          else boxes[b].value = want;
        }
      }
      updateLabels();
    }

    function updateGallery(v) {
      /* colour galleries: show the thumbs of this variant's group plus the shared ones */
      var grouped = false, shown = 0;
      for (var g = 0; g < el.thumbs.length; g++) {
        if (el.thumbs[g].getAttribute('data-vgroup') !== 'all') grouped = true;
      }
      if (grouped && v.image) {
        for (var k = 0; k < el.thumbs.length; k++) {
          var grp = el.thumbs[k].getAttribute('data-vgroup');
          var show = grp === 'all' || grp === String(v.id);
          el.thumbs[k].hidden = !show;
          el.thumbs[k].style.display = show ? '' : 'none';
          if (show) shown++;
        }
        var wrap = el.thumbs[0] && el.thumbs[0].parentNode;
        if (wrap) wrap.style.display = shown > 1 ? '' : 'none';
      }
      if (!el.img || !v.image) return;
      if (el.img.getAttribute('src') === v.image) return;
      el.img.src = v.image;
      el.img.classList.remove('ph');
      var base = v.image.split('?')[0];
      var matched = false;
      for (var i = 0; i < el.thumbs.length; i++) {
        var full = (el.thumbs[i].getAttribute('data-full') || '').split('?')[0];
        var on = full && base.indexOf(full) === 0;
        el.thumbs[i].classList.toggle('on', !!on);
        if (on) matched = true;
      }
      if (!matched && el.thumbs.length) el.thumbs[0].classList.add('on');
    }

    function apply(v) {
      if (!v) return;

      /* the add-to-cart / buy-now target — read by the inline onclick handlers in the section */
      if (el.vid) el.vid.value = v.id;

      setText(el.now, v.price);
      setText(el.buyPrice, v.price);
      setText(el.stickyPrice, v.price);

      if (el.was) {
        show(el.was, !!v.compare);
        var s = el.was.querySelector('s') || el.was;
        if (v.compare) setText(s, 'JOD ' + v.compare);
      }
      show(el.save, !!v.save);
      setText(el.save, v.save || '');

      if (el.sku) setText(el.sku, v.sku || '');
      show(el.skuWrap, !!v.sku);
      if (el.barcode) setText(el.barcode, v.barcode || '');
      show(el.barcodeWrap, !!v.barcode);

      show(el.buyRow, v.available);
      show(el.soldOut, !v.available);
      show(el.stickyBtn, v.available);
      if (el.buyNow && data.cart_url) el.buyNow.href = data.cart_url + '/' + v.id + ':1';

      if (freeMin) {
        var free = Number(v.raw_price) >= freeMin;
        show(el.delivFree, free);
        show(el.delivPaid, !free);
      }

      setText(note, v.available ? '' : (data.sold_out_text || ''));

      updateGallery(v);
      updateRadios();

      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({ path: url.href }, '', url.href);
      } catch (e) { /* older browsers: not fatal */ }

      document.dispatchEvent(new CustomEvent('dvp:variantchange', { detail: { variant: v, product_id: data.product_id } }));
    }

    function onChange() {
      var vals = selectedValues();
      var v = findVariant(vals);
      if (v) { updateLabels(); apply(v); return; }

      /* no variant exists for this exact combination: keep the shopper's last-changed value
         and fall back to the nearest variant that has it (purchasable one preferred) */
      var last = vals[options.length - 1];
      var loose = null, looseAvail = null, anyAvail = null;
      for (var i = 0; i < variants.length; i++) {
        var cand = variants[i];
        if (!looseAvail && cand.available) anyAvail = cand;
        if (cand.options[options.length - 1] !== last) continue;
        if (!loose) loose = cand;
        if (cand.available && !looseAvail) looseAvail = cand;
      }
      v = looseAvail || loose || anyAvail || variants[0];
      syncInputs(v);
      apply(v);
    }

    for (var i = 0; i < inputs.length; i++) inputs[i].addEventListener('change', onChange);

    /* first paint: honour ?variant= from the URL when it is a real variant of this product */
    var wanted = null;
    try { wanted = new URL(window.location.href).searchParams.get('variant'); } catch (e) {}
    var start = (wanted && byId(String(wanted))) || byId(data.selected_id) || findVariant(selectedValues()) || variants[0];
    syncInputs(start);
    apply(start);
  }

  function boot(scope) {
    var roots = (scope || document).querySelectorAll('[data-dvp]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();

  /* re-init after a theme-editor section re-render */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelectorAll) {
      var nodes = e.target.querySelectorAll('[data-dvp]');
      for (var i = 0; i < nodes.length; i++) { nodes[i].removeAttribute('data-dvp-ready'); init(nodes[i]); }
    }
  });
})();
